
<section>
  <div>
    <app-warranty-filter-section (filters)="receiveUpdatedFilters($event)"></app-warranty-filter-section>
  </div>
  <div *ngIf="pagedWarranties$ | async as pagedWarranties; else spinner">
    <app-table-issue-warranties 
    (pagination)="receiveChangePagination($event)"
    (sorting)="receiveSorting($event)"
    (notify)="getIssueWarranties()"
    [warranties]="pagedWarranties.results"
    [totalRows]="pagedWarranties.totalRows"
    [pageSize]="warrantyParams.pageSize"
    [page]="warrantyParams.page"
    [sortColumn]="warrantyParams.sortColumn"
    [sortDirection]="warrantyParams.sortDirection">
    </app-table-issue-warranties>
  </div>
</section>

<ng-template #spinner>
  <div class="spinner-section">
    <mat-spinner diameter="70"></mat-spinner>
  </div>
</ng-template>